import { fromJS } from 'immutable'
export default fromJS({
  upload: { selectFile: 'Dokument auswählen...' },
  form: { name: 'Name: ${name}' },
  shared: {
    components: {
      form: {
        businessPlaceInput: {
          moreNearbyResults: 'Weitere Geschäfte in der Nähe anzeigen',
          error: {
            couldNotFindNearbyResults:
              'Es konnten keine Ergebnisse in der Nähe zu einem bestimmten Ort gefunden werden.',
          },
          noResultsMessage: 'Keine Ergebnisse gefunden.',
          chosen: 'Ausgewählter Standort',
          label: 'Name oder Adresse suchen...',
          choose: 'Bitte wählen Sie:',
          orClickOnMap: '... oder klicken Sie in die Karte',
          currentMarkerSelection: 'Gesetze Markierung:',
          nearby: 'In der Nähe:',
        },
      },
    },
  },
  error: { network: 'Die Verbindung zum Server konnte nicht aufgebaut werden.' },
  names: { lastName: 'Nachname', firstName: 'Vorname' },
  errors: {
    acceptance: 'Bitte bestätigen sie die Checkbox.',
    default: 'Bitte füllen Sie dieses Feld aus.',
    canNotConnectToServer: 'Momentan kann der Server nicht erreicht werden.',
    iban: 'Bitte geben Sie eine gültige IBAN an.',
    fileTooBig: 'Die Datei ${name} ist zu gross für den Upload.',
    uploadBlocked: 'Ein Dokument wurde blockiert oder konnte nicht verarbeitet werden.',
    time: 'Bitte geben Sie ein gültiges Zeitformat an.',
    phone: 'Bitte geben Sie eine gültige Telefonnummer an.',
    date: 'Bitte geben Sie ein gültiges Datum an.',
    fileTooSmall: 'Die Datei ${name} ist zu klein für den Upload.',
    currency: 'Bitte geben Sie einen gültigen Betrag an.',
    file: 'Bitte eine Datei auswählen.',
    email: 'Bitte geben Sie eine gültige E-Mail-Adresse an.',
    boundaryError: 'Ein Fehler ist aufgetreten.',
    inputContainsBinRange: 'Bitte übermitteln Sie uns keine Kreditkartennummer.',
  },
  genders: { female: 'Frau', male: 'Herr' },
  button: { send: 'Absenden', delete: 'Entfernen' },
  address: { city: 'Ort', zip: 'PLZ', street: 'Strasse' },
  confirmation: { backHome: 'Zur Startseite' },
  not_found: { title: 'Das Formular konnte nicht gefunden werden.' },
  format: { time: 'HH:MM', date: 'TT.MM.JJJJ' },
  loading: { title: 'Laden...' },
})
